<script>
    import { Navigate } from "svelte-router-spa";
    import { alumnos } from "../MainStore.js";
    import AlumnoItem from "./AlumnoItem/AlumnoItem.svelte";

    export let currentRoute;
    export let params;

    alumnos.actualizarDatos();

    const currentPath = currentRoute.name.replace("/index", "");
</script>

<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col-4 my-auto">
                Alumnos
            </div>
            <div class="col text-right">
                <Navigate to={`${currentPath}/agregaralumno`}>
                    <button class="btn btn-raised btn-success">Agregar</button>
                </Navigate>
            </div>
        </div>
    </div>
    <div class="card-body">
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">Nombre y Apellido</th>
                    <th scope="col">DNI</th>
                    <th scope="col">Cohorte</th>
                    <th scope="col">L/F</th>
                    <th scope="col">Promedio</th>
                    <th scope="col">% carrera</th>
                    <th scope="col">Materias aprobadas</th>
                    <th scope="col">Materias cursadas</th>
                </tr>
            </thead>
            <tbody>
                {#each $alumnos as alumno}
                    <AlumnoItem alumno={alumno} />
                {/each}
            </tbody>
        </table>
    </div>
</div>